module.exports = __webpack_public_path__ + "img/difficultyLevel_5_gray.fb2713d4.svg";